<template>
    <div id="app">
        <v-card flat tile id="bundle-view">
            <v-snackbar
                    v-model="everythingSavedSuccesfully"
                    :bottom="y === 'bottom'"
                    :color=snackbarColor
                    :timeout="timeout"
                    :top="y === 'top'"
            >
                <v-icon style="color: white; padding-right: 2vw">
                    {{snackbarIcon}}
                </v-icon>
                {{snackbarText}}
                <v-btn
                        color="white"
                        text
                        @click="everythingSavedSuccesfully = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>

            <v-overlay
                    absolute="absolute"
                    opacity="0.9"
                    color="white"
                    :value="editApproveOverlay">

                <v-card dark style="height: 65%; width: 70vw; margin-left: auto; margin-right: auto">


                    <div style="width: 100%; height: 100%">
                        <div style="width: 100%; height: 20%; font-weight: bold; font-size: 2vw; display: flex; justify-content: center; align-items: center">
                            Confirm to Continue
                        </div>


                        <div style="width: 100%; padding-left: 10%; padding-right: 10%; height: 30%; text-align: center; font-size: 2vh">

                            You are about to access a editor which controls the bundle prices and payouts for the customers.
                            To continue with the editor please enter and match the word "<b>Confirm</b>" without the speech marks and click on the "Continue" button displayed below.

                        </div>

                        <div style="width: 100%; height: 20%;padding-left: 10%; padding-right: 10%; display: flex; justify-content: center; align-items: center">

                            <v-text-field
                                    label="Enter 'Confirm' here"
                                    rounded
                                    outlined
                                    v-model="confirmMessage"
                                    clearable>

                            </v-text-field>
                        </div>

                        <div style="width: 100%; height: 30%;  display: flex; justify-content: center; align-items: center">

                            <v-btn light @click="editApproveOverlay = false; confirmMessage = ''" :disabled="editButtonDisabled" style="width: 40%; height: 50%" rounded>Continue</v-btn>

                        </div>
                    </div>

                </v-card>

            </v-overlay>

            <div id="bundle-options">

                <div class="bundle-section" style="border-right-style: solid; border-width: 1px; border-color: lightgray">

                    <div class="bundle-section-header">

                        <div class="section-header-content" v-bind:style="{color: computedBronzeSectionColor}">
                            <v-badge color="white">
                                <template v-slot:badge>

                                    <v-icon :color="computedBronzeSectionColor">{{computedBronzeSection}}</v-icon>

                                </template>
                                Bronze
                            </v-badge>
                        </div>

                        <div class="restore-payments">
                            <v-btn style="float: right;" @click="restoreBronze" icon x-small color="blue"><v-icon>fas fa-undo-alt</v-icon></v-btn>
                        </div>

                    </div>

                    <div class="bundle-section-content">
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Bronze Price UK"
                                          v-model="bronzeUkPayment"
                                          prefix="£"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          rounded
                                          clearable
                                          outlined
                                          hint="Please specify the cost of the bundle for the UK customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">
                            <v-text-field style="transform: scale(0.85)"
                                          label="Bronze Credit UK"
                                          v-model="bronzeUkCredit"
                                          prefix="£"
                                          :rules="rules.name"
                                          rounded
                                          clearable
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"

                                          outlined

                                          hint="Please specify the credit amount for the UK customer"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Bronze Price AUS"
                                          v-model="bronzeAsPayment"
                                          clearable
                                          prefix="$"
                                          :rules="rules.name"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          outlined
                                          rounded
                                          hint="Please specify the cost of the bundle for the AUS customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Bronze Credit AUS"
                                          clearable
                                          v-model="bronzeAsCredit"
                                          prefix="c"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          outlined
                                          rounded
                                          hint="Please specify the credit amount for the AUS customer"

                            ></v-text-field>

                        </div>

                    </div>

                </div>

                <div class="bundle-section">

                    <div class="bundle-section-header">

                        <div class="section-header-content" v-bind:style="{color: computedSilverSectionColor}">
                            <v-badge color="white">
                                <template v-slot:badge>

                                    <v-icon :color="computedSilverSectionColor">{{computedSilverSection}}</v-icon>

                                </template>
                                Silver
                            </v-badge>
                        </div>

                        <div class="restore-payments">
                            <v-btn style="float: right;" @click="restoreSilver" icon x-small color="blue"><v-icon>fas fa-undo-alt</v-icon></v-btn>
                        </div>

                    </div>

                    <div class="bundle-section-content">
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Silver Price UK"
                                          v-model="silverUkPayment"
                                          prefix="£"
                                          rounded
                                          clearable
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          outlined
                                          hint="Please specify the cost of the bundle for the UK customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">
                            <v-text-field style="transform: scale(0.85)"
                                          label="Silver Credit UK"
                                          prefix="£"
                                          rounded
                                          clearable
                                          v-model="silverUkCredit"
                                          :rules="rules.name"
                                          outlined
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          hint="Please specify the credit amount for the UK customer"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Silver Price AUS"
                                          clearable
                                          prefix="$"
                                          v-model="silverAsPayment"
                                          :rules="rules.name"
                                          outlined
                                          rounded
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          hint="Please specify the cost of the bundle for the AUS customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Silver Credit AUS"
                                          clearable
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          prefix="c"
                                          v-model="silverAsCredit"
                                          :rules="rules.name"
                                          outlined
                                          rounded
                                          hint="Please specify the credit amount for the AUS customer"

                            ></v-text-field>

                        </div>

                    </div>

                </div>

                <div class="bundle-section" style="border-right-style: solid; border-top-style: solid; border-width: 1px; border-color: lightgray">

                    <div class="bundle-section-header">

                        <div class="section-header-content" v-bind:style="{color: computedGoldSectionColor}">
                            <v-badge color="white">
                                <template v-slot:badge>

                                    <v-icon :color="computedGoldSectionColor">{{computedGoldSection}}</v-icon>

                                </template>
                                Gold
                            </v-badge>
                        </div>

                        <div class="restore-payments">
                            <v-btn style="float: right;" @click="restoreGold" icon x-small color="blue"><v-icon>fas fa-undo-alt</v-icon></v-btn>
                        </div>

                    </div>

                    <div class="bundle-section-content">
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Gold Price UK"
                                          v-model="goldUkPayment"
                                          prefix="£"
                                          rounded
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          clearable
                                          outlined
                                          hint="Please specify the cost of the bundle for the UK customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">
                            <v-text-field style="transform: scale(0.85)"
                                          label="Gold Credit UK"
                                          v-model="goldUkCredit"
                                          prefix="£"
                                          rounded
                                          clearable
                                          :rules="rules.name"
                                          outlined
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          hint="Please specify the credit amount for the UK customer"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Gold Price AUS"
                                          v-model="goldAsPayment"
                                          clearable
                                          prefix="$"
                                          outlined
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          rounded
                                          hint="Please specify the cost of the bundle for the AUS customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Gold Credit AUS"
                                          clearable
                                          v-model="goldAsCredit"
                                          prefix="c"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          outlined
                                          rounded
                                          hint="Please specify the credit amount for the AUS customer"

                            ></v-text-field>

                        </div>

                    </div>

                </div>

                <div class="bundle-section" style="border-top-style: solid; border-width: 1px; border-color: lightgray">

                    <div class="bundle-section-header">

                        <div class="section-header-content" v-bind:style="{color: computedPlatinumSectionColor}">
                            <v-badge color="white">
                                <template v-slot:badge>

                                    <v-icon :color="computedPlatinumSectionColor">{{computedPlatinumSection}}</v-icon>

                                </template>
                                Platinum
                            </v-badge>
                        </div>

                        <div class="restore-payments">
                            <v-btn style="float: right;" @click="restorePlatinum" icon x-small color="blue"><v-icon>fas fa-undo-alt</v-icon></v-btn>
                        </div>

                    </div>

                    <div class="bundle-section-content">
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Platinum Price UK"
                                          prefix="£"
                                          v-model="platinumUkPayment"
                                          rounded
                                          :rules="rules.name"
                                          clearable
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          outlined
                                          hint="Please specify the cost of the bundle for the UK customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">
                            <v-text-field style="transform: scale(0.85)"
                                          label="Platinum Credit UK"
                                          prefix="£"
                                          rounded
                                          clearable
                                          v-model="platinumUkCredit"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          outlined
                                          :rules="rules.name"
                                          hint="Please specify the credit amount for the UK customer"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Platinum Price AUS"
                                          clearable
                                          prefix="$"
                                          outlined
                                          v-model="platinumAsPayment"
                                          rounded
                                          :rules="rules.name"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          hint="Please specify the cost of the bundle for the AUS customers"

                            ></v-text-field>

                        </div>
                        <div class="content-text-area-wrapper">

                            <v-text-field style="transform: scale(0.85)"
                                          label="Platinum Credit AUS"
                                          clearable
                                          v-model="platinumAsCredit"
                                          prefix="c"
                                          type="number"
                                          min="0"
                                          max="10000"
                                          step="1"
                                          :rules="rules.name"
                                          outlined
                                          rounded
                                          hint="Please specify the credit amount for the AUS customer"

                            ></v-text-field>

                        </div>

                    </div>

                </div>

            </div>

            <div id="bundle-changes">

                <v-btn @click="saveBundles();" style="color:white" :disabled="computedDisableButton" color="#2e2e2e" rounded id="save-button">Save Changes</v-btn>

            </div>

        </v-card>

    </div>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { AXIOS } from '../../http-common'
Vue.use(Vuetify)
export default {

  props: ['closeBundleScreen'],

  data () {
    return {

      parentModal: this.closeBundleScreen,

      confirmMessage: '',

      editApproveOverlay: true,

      y: 'top',
      timeout: 2000,

      bronzeBundle: {},
      silverBundle: {},
      goldBundle: {},
      platinumBundle: {},

      bronzeUkPayment: {},
      bronzeAsPayment: {},
      bronzeUkCredit: {},
      bronzeAsCredit: {},

      silverUkPayment: {},
      silverAsPayment: {},
      silverUkCredit: {},
      silverAsCredit: {},

      goldUkPayment: {},
      goldAsPayment: {},
      goldUkCredit: {},
      goldAsCredit: {},

      platinumUkPayment: {},
      platinumAsPayment: {},
      platinumUkCredit: {},
      platinumAsCredit: {},

      bronzeUkPaymentPresent: '',
      bronzeAsPaymentPresent: '',
      bronzeUkCreditPresent: '',
      bronzeAsCreditPresent: '',
      bronzeDetailsCompleted: '',
      bronzePresentIcon: '',

      silverUkPaymentPresent: '',
      silverAsPaymentPresent: '',
      silverUkCreditPresent: '',
      silverAsCreditPresent: '',
      silverDetailsCompleted: '',
      silverPresentIcon: '',

      goldUkPaymentPresent: '',
      goldAsPaymentPresent: '',
      goldUkCreditPresent: '',
      goldAsCreditPresent: '',
      goldDetailsCompleted: '',
      goldPresentIcon: '',

      platinumUkPaymentPresent: '',
      platinumAsPaymentPresent: '',
      platinumUkCreditPresent: '',
      platinumAsCreditPresent: '',
      platinumDetailsCompleted: '',
      platinumPresentIcon: '',

      editButtonDisabled: true,

      bronzeSuccess: '',
      bronzeError: '',

      silverSuccess: '',
      silverError: '',

      goldSuccess: '',
      goldError: '',

      platinumSuccess: '',
      platinumError: '',

      everythingSavedSuccesfully: '',

      snackbarText: '',
      snackbarColor: '',
      snackbarIcon: '',

      rules: { // Checks field length if 0 say 'Required field'
        name: [val => (val || '').length > 0 || 'Required field']
      }
    }
  },
  watch: {

    confirmMessage: function () {
      if (this.confirmMessage == 'Confirm') {
        this.editButtonDisabled = false
      } else {
        this.editButtonDisabled = true
      }
    },

    bronzeUkPayment: function () {
      if (this.bronzeUkPayment == null || this.bronzeUkPayment == '') {
        this.bronzeUkPaymentPresent = false
      } else if (this.bronzeUkPayment <= -1) {
        this.bronzeUkPayment = 0
      } else {
        this.bronzeUkPaymentPresent = true
      }
    },

    bronzeAsPayment: function () {
      if (this.bronzeAsPayment == null || this.bronzeAsPayment == '') {
        this.bronzeAsPaymentPresent = false
      } else if (this.bronzeAsPayment <= -1) {
        this.bronzeAsPayment = 0
      } else {
        this.bronzeAsPaymentPresent = true
      }
    },
    bronzeUkCredit: function () {
      if (this.bronzeUkCredit == null || this.bronzeUkCredit == '') {
        this.bronzeUkCreditPresent = false
      } else if (this.bronzeUkCredit <= -1) {
        this.bronzeUkCredit = 0
      } else {
        this.bronzeUkCreditPresent = true
      }
    },
    bronzeAsCredit: function () {
      if (this.bronzeAsCredit == null || this.bronzeAsCredit == '') {
        this.bronzeAsCreditPresent = false
      } else if (this.bronzeAsCredit <= -1) {
        this.bronzeAsCredit = 0
      } else {
        this.bronzeAsCreditPresent = true
      }
    },

    silverUkPayment: function () {
      if (this.silverUkPayment == null || this.silverUkPayment == '') {
        this.silverUkPaymentPresent = false
      } else if (this.silverUkPayment <= -1) {
        this.silverUkPayment = 0
      } else {
        this.silverUkPaymentPresent = true
      }
    },

    silverAsPayment: function () {
      if (this.silverAsPayment == null || this.silverAsPayment == '') {
        this.silverAsPaymentPresent = false
      } else if (this.silverAsPayment <= -1) {
        this.silverAsPayment = 0
      } else {
        this.silverAsPaymentPresent = true
      }
    },
    silverUkCredit: function () {
      if (this.silverUkCredit == null || this.silverUkCredit == '') {
        this.silverUkCreditPresent = false
      } else if (this.silverUkCredit <= -1) {
        this.silverUkCredit = 0
      } else {
        this.silverUkCreditPresent = true
      }
    },
    silverAsCredit: function () {
      if (this.silverAsCredit == null || this.silverAsCredit == '') {
        this.silverAsCreditPresent = false
      } else if (this.silverAsCredit <= -1) {
        this.silverAsCredit = 0
      } else {
        this.silverAsCreditPresent = true
      }
    },

    goldUkPayment: function () {
      if (this.goldUkPayment == null || this.goldUkPayment == '') {
        this.goldUkPaymentPresent = false
      } else if (this.goldUkPayment <= -1) {
        this.goldUkPayment = 0
      } else {
        this.goldUkPaymentPresent = true
      }
    },

    goldAsPayment: function () {
      if (this.goldAsPayment == null || this.goldAsPayment == '') {
        this.goldAsPaymentPresent = false
      } else if (this.goldAsPayment <= -1) {
        this.goldAsPayment = 0
      } else {
        this.goldAsPaymentPresent = true
      }
    },
    goldUkCredit: function () {
      if (this.goldUkCredit == null || this.goldUkCredit == '') {
        this.goldUkCreditPresent = false
      } else if (this.goldUkCredit <= -1) {
        this.goldUkCredit = 0
      } else {
        this.goldUkCreditPresent = true
      }
    },
    goldAsCredit: function () {
      if (this.goldAsCredit == null || this.goldAsCredit == '') {
        this.goldAsCreditPresent = false
      } else if (this.goldAsCredit <= -1) {
        this.goldAsCredit = 0
      } else {
        this.goldAsCreditPresent = true
      }
    },

    platinumUkPayment: function () {
      if (this.platinumUkPayment == null || this.platinumUkPayment == '') {
        this.platinumUkPaymentPresent = false
      } else if (this.platinumUkPayment <= -1) {
        this.platinumUkPayment = 0
      } else {
        this.platinumUkPaymentPresent = true
      }
    },

    platinumAsPayment: function () {
      if (this.platinumAsPayment == null || this.platinumAsPayment == '') {
        this.platinumAsPaymentPresent = false
      } else if (this.platinumAsPayment <= -1) {
        this.platinumAsPayment = 0
      } else {
        this.platinumAsPaymentPresent = true
      }
    },
    platinumUkCredit: function () {
      if (this.platinumUkCredit == null || this.platinumUkCredit == '') {
        this.platinumUkCreditPresent = false
      } else if (this.platinumUkCredit <= -1) {
        this.platinumUkCredit = 0
      } else {
        this.platinumUkCreditPresent = true
      }
    },
    platinumAsCredit: function () {
      if (this.platinumAsCredit == null || this.platinumAsCredit == '') {
        this.platinumAsCreditPresent = false
      } else if (this.platinumAsCredit <= -1) {
        this.platinumAsCredit = 0
      } else {
        this.platinumAsCreditPresent = true
      }
    }

  },
  created: function () {
    // On load gets bundle information
    document.title = 'Chattube - Bundles'
    this.getBundleInfo()
  },
  computed: {

    computedBronzeSection () {
      if (this.bronzeUkCreditPresent == true && this.bronzeUkPaymentPresent == true && this.bronzeAsCreditPresent == true && this.bronzeAsPaymentPresent == true) {
        this.bronzePresentIcon = 'check_circle'
      } else { this.bronzePresentIcon = 'error' }
      return this.bronzePresentIcon
    },
    computedBronzeSectionColor () {
      if (this.bronzeUkCreditPresent == true && this.bronzeUkPaymentPresent == true && this.bronzeAsCreditPresent == true && this.bronzeAsPaymentPresent == true) {
        var color = 'green'
      } else { var color = 'red' }
      return color
    },

    computedSilverSection () {
      if (this.silverUkCreditPresent == true && this.silverUkPaymentPresent == true && this.silverAsCreditPresent == true && this.silverAsPaymentPresent == true) {
        this.silverPresentIcon = 'check_circle'
      } else { this.silverPresentIcon = 'error' }
      return this.silverPresentIcon
    },
    computedSilverSectionColor () {
      if (this.silverUkCreditPresent == true && this.silverUkPaymentPresent == true && this.silverAsCreditPresent == true && this.silverAsPaymentPresent == true) {
        var color = 'green'
      } else { var color = 'red' }
      return color
    },

    computedGoldSection () {
      if (this.goldUkCreditPresent == true && this.goldUkPaymentPresent == true && this.goldAsCreditPresent == true && this.goldAsPaymentPresent == true) {
        this.goldPresentIcon = 'check_circle'
      } else { this.goldPresentIcon = 'error' }
      return this.goldPresentIcon
    },
    computedGoldSectionColor () {
      if (this.goldUkCreditPresent == true && this.goldUkPaymentPresent == true && this.goldAsCreditPresent == true && this.goldAsPaymentPresent == true) {
        var color = 'green'
      } else { var color = 'red' }
      return color
    },

    computedPlatinumSection () {
      if (this.platinumUkCreditPresent == true && this.platinumUkPaymentPresent == true && this.platinumAsCreditPresent == true && this.platinumAsPaymentPresent == true) {
        this.platinumPresentIcon = 'check_circle'
      } else { this.platinumPresentIcon = 'error' }
      return this.platinumPresentIcon
    },
    computedPlatinumSectionColor () {
      if (this.platinumUkCreditPresent == true && this.platinumUkPaymentPresent == true && this.platinumAsCreditPresent == true && this.platinumAsPaymentPresent == true) {
        var color = 'green'
      } else { var color = 'red' }
      return color
    },

    computedDisableButton () {
      if (this.bronzePresentIcon == 'check_circle' && this.silverPresentIcon == 'check_circle' && this.goldPresentIcon == 'check_circle' && this.platinumPresentIcon == 'check_circle') {
        this.enableButton = false
      } else {
        this.enableButton = true
      }
      return this.enableButton
    }

  },
  methods: {

    restoreBronze () {
      this.bronzeUkPayment = '20'
      this.bronzeAsPayment = '20'
      this.bronzeUkCredit = '30'
      this.bronzeAsCredit = '30'
    },

    restoreSilver () {
      this.silverUkPayment = '50'
      this.silverAsPayment = '50'
      this.silverUkCredit = '80'
      this.silverAsCredit = '80'
    },

    restoreGold () {
      this.goldUkPayment = '100'
      this.goldAsPayment = '100'
      this.goldUkCredit = '170'
      this.goldAsCredit = '170'
    },

    restorePlatinum () {
      this.platinumUkPayment = '250'
      this.platinumAsPayment = '250'
      this.platinumUkCredit = '425'
      this.platinumAsCredit = '425'
    },

    getBundleInfo () {
      AXIOS({
        method: 'GET',
        url: '/api/bundle',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        }
      }).then(response => {
        this.bronzeBundle = response.data.filter(kp6 => kp6.id === 1)
        this.silverBundle = response.data.filter(kp6 => kp6.id === 2)
        this.goldBundle = response.data.filter(kp6 => kp6.id === 3)
        this.platinumBundle = response.data.filter(kp6 => kp6.id === 4)

        this.bronzeUkPayment = this.bronzeBundle[0].amountUk.toString()
        this.bronzeAsPayment = this.bronzeBundle[0].amountAs.toString()
        this.bronzeUkCredit = this.bronzeBundle[0].creditUk.toString()
        this.bronzeAsCredit = this.bronzeBundle[0].creditAs.toString()

        this.silverUkPayment = this.silverBundle[0].amountUk.toString()
        this.silverAsPayment = this.silverBundle[0].amountAs.toString()
        this.silverUkCredit = this.silverBundle[0].creditUk.toString()
        this.silverAsCredit = this.silverBundle[0].creditAs.toString()

        this.goldUkPayment = this.goldBundle[0].amountUk.toString()
        this.goldAsPayment = this.goldBundle[0].amountAs.toString()
        this.goldUkCredit = this.goldBundle[0].creditUk.toString()
        this.goldAsCredit = this.goldBundle[0].creditAs.toString()

        this.platinumUkPayment = this.platinumBundle[0].amountUk.toString()
        this.platinumAsPayment = this.platinumBundle[0].amountAs.toString()
        this.platinumUkCredit = this.platinumBundle[0].creditUk.toString()
        this.platinumAsCredit = this.platinumBundle[0].creditAs.toString()
      })
    },

    saveBundles () {
      this.saveBronzeBundle()
      this.saveSilverBundle()
      this.saveGoldBundle()
      this.savePlatinumBundle()
      setTimeout(() => this.checkIfAllSavedSuccess(), 1000)
      setTimeout(() => this.getBundleInfo(), 500)
      setTimeout(() => this.editApproveOverlay = true, 2000)
    },

    saveBronzeBundle () {
      // Executes call to the database
      AXIOS({
        method: 'POST',
        url: 'api/admin/bundle/save',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.bronzeBundle[0].id,
          bundleName: this.bronzeBundle[0].bundleName,
          amountUk: this.bronzeUkPayment,
          amountAs: this.bronzeAsPayment,
          creditUk: this.bronzeUkCredit,
          creditAs: this.bronzeAsCredit
        }
      })
        .then(response => {
          this.bronzeSuccess = true
          this.bronzeError = false
        },
        (err) => {
          this.bronzeError = true
          this.bronzeSuccess = false
        }
        )
    },

    saveSilverBundle () {
      // Executes call to the database
      AXIOS({
        method: 'POST',
        url: 'api/admin/bundle/save',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.silverBundle[0].id,
          bundleName: this.silverBundle[0].bundleName,
          amountUk: this.silverUkPayment,
          amountAs: this.silverAsPayment,
          creditUk: this.silverUkCredit,
          creditAs: this.silverAsCredit

        }
      })
        .then(response => {
          this.silverSuccess = true
          this.silverError = false
        },
        (err) => {
          this.silverError = true
          this.silverSuccess = false
        }
        )
    },

    saveGoldBundle () {
      // Executes call to the database
      AXIOS({
        method: 'POST',
        url: 'api/admin/bundle/save',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.goldBundle[0].id,
          bundleName: this.goldBundle[0].bundleName,
          amountUk: this.goldUkPayment,
          amountAs: this.goldAsPayment,
          creditUk: this.goldUkCredit,
          creditAs: this.goldAsCredit
        }
      })
        .then(response => {
          this.goldSuccess = true
          this.goldError = false
        },
        (err) => {
          this.goldError = true
          this.goldSuccess = false
        }
        )
    },

    savePlatinumBundle () {
      // Executes call to the database
      AXIOS({
        method: 'POST',
        url: 'api/admin/bundle/save',
        headers: {
          Authorization: 'Bearer ' + window.$cookies.get('session')
        },
        data: {
          id: this.platinumBundle[0].id,
          bundleName: this.platinumBundle[0].bundleName,
          amountUk: this.platinumUkPayment,
          amountAs: this.platinumAsPayment,
          creditUk: this.platinumUkCredit,
          creditAs: this.platinumAsCredit

        }
      })
        .then(response => {
          this.platinumSuccess = true

          this.platinumError = false
        },
        (err) => {
          this.platinumError = true

          this.platinumSuccess = false
        }
        )
    },

    checkIfAllSavedSuccess () {
      if (this.bronzeSuccess == true && this.silverSuccess == true && this.goldSuccess == true && this.platinumSuccess == true) {
        this.everythingSavedSuccesfully = true

        this.snackbarText = 'Bundles Saved'
        this.snackbarColor = 'green'
        this.snackbarIcon = 'check_circle'

        this.parentModal = false

        // setTimeout(() => this.$emit('bundleScreenModalTrigger', this.parentModal),2500);
      } else {
        this.everythingSavedSuccesfully = false

        this.snackbarText = 'Something Went Wrong'
        this.snackbarColor = 'red'
        this.snackbarIcon = 'error'
      }
    }

  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
    }

    #bundle-view {
        height: 100%;
        width: 100%;

    }
    #bundle-options {
        height: 75%;
        width: 100%;

    }
    #bundle-changes {
        height: 15%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    #save-button {

        width: 50%; height: 50%;
        font-size: 1vw;

    }
    .bundle-section {
        height: 50%;
        width: 50%;
        float: left;

    }
    .bundle-section-header {
        height: 15%;
        width: 100%;

        font-weight: bold;
        font-size: 1.25vh;
        display: flex;
        justify-content: left;
        align-items: center;
        padding-left: 2%;
    }

    .section-header-content {
        height: 100%;
        width: 90%;
        float: left;
        text-align: left;
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 2vh;
    }

    .bundle-section-content {
        height: 85%;
        width: 100%;

    }

    .content-text-area-wrapper {
        height: 50%;
        width: 50%;
        float: left;

        display: flex;
        justify-content: center;
        align-items: center;
    }
    .restore-payments {
        height: 100%; width: 10%; float: right; padding-right: 3%; display: flex; justify-content: left; align-items: center
    }

</style>
